import type { Debit } from 'interfaces';
import { parseDateTime } from 'utils/dateParsing';

export interface ClaimQueryRemittance {
  value: string;
  label: string;
  microfilm: string;
  date: string;
  debits: Debit[];
}

export const getClaimQueryRemittances = (
  debits: Debit[],
  timezone: string
): ClaimQueryRemittance[] => {
  const sorted = debits
    .filter((debit) => debit.microfilm && debit.source !== 'MANUAL')
    .map((debit) => ({
      debit,
      received: parseDateTime(debit.createdAt, { zone: 'utc' }),
    }))
    .filter(({ received }) => received.isValid)
    .sort((a, b) => b.received.toMillis() - a.received.toMillis());
  const remittances = new Map<string, ClaimQueryRemittance>();
  for (const { debit, received } of sorted) {
    const microfilm = debit.microfilm;
    const date = received.setZone(timezone).toISODate();
    if (!microfilm || !date) continue;
    const value = JSON.stringify([microfilm, date]);
    const existing = remittances.get(value);
    if (existing) {
      existing.debits.push(debit);
      continue;
    }
    remittances.set(value, {
      value,
      label: `${microfilm} (${date})`,
      microfilm,
      date,
      debits: [debit],
    });
  }
  return Array.from(remittances.values());
};
